import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { type ModalComponentProps } from '@atlassian/entry-points/modal-context-provider';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ModalFixtureComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	ModalComponentProps,
	Record<string, never>
>;

export const errorModalEntryPoint: EntryPoint<ModalFixtureComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<ModalFixtureComponent>('../modal-ui.tsx', {
		moduleId: 'error-modal-entrypoint',
		chain: (promise) =>
			promise.then(() => new Promise((_, reject) => reject(new Error('Failed to load module')))),
	}),
	getPreloadProps: () => ({}),
});
